module.exports = __webpack_public_path__ + "img/backyard-patio.60a7000b.jpg";